<template>
  <div class="container">
    <v-touch v-on:swipeup="swipeup" v-on:swipedown="swipedown" class="wrapper">
      <div class="menu-container" ref="menuContainer">
        <div class="videodiv">
          <video id="video" src="static/img/start.mp4" controls preload playsinline="true" webkit-playsinline="true" x5-playsinline="true"></video>
          <!-- <div class="bt" @click="urlchange">剪影·百年</div> -->
        </div>
      </div>
    </v-touch>
    <!-- <router-view/> -->
    <keep-alive include="cut">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name:'start',
  data() {
    return {

    }
  },
  mounted(){
    console.log('=================== start.vue ');
    var wx = require('weixin-js-sdk');
    wx.config({
        debug: false,
        appId: '',
        timestamp: 1,
        nonceStr: '',
        signature: '',
        jsApiList: [],
        info:{}
    });
    wx.ready(function() {
        // alert('a1111');
        let video = document.querySelector("#video");
        console.log('aaaaa - video - ',video);
        video.play();
        video.pause();
    });

    var video = document.getElementById("video");
    var that = this;
    video.addEventListener('ended',function(){
      console.log('播放结束');
      that.$router.push('/cut');
    },false)
  },
  methods:{
    urlchange(){
      this.$router.push('/cut');
    },
    swipeup(){
      console.log('1');
      this.$router.push('/cut');
    },
    swipedown(){
      console.log('2');
      this.$router.push('/cut');
    }
  }
}
</script>
<style scoped>
video{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.videodiv{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
}
.bt{
  background: orange;
  color: white;
  font-weight: bold;
  padding: 10px 15px;
  border-radius: 30px;
  position: absolute;
  bottom: 30vw;
  right: 5vw;
  width: 40%;
  z-index: 50;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/start.vue